module.exports = __webpack_public_path__ + "site/img/145.45103e02.jpg";